import Dialog from "dialog";
import template from "../html/dialog-config-pump-antifoam.html";
import css from "../css/dialog-config-pump-antifoam.css";

class ConfigAntifoamPumpDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-pump-antifoam", ConfigAntifoamPumpDialog);
	}
	constructor() {
		super();

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	connectedCallback() {
		super.connectedCallback();

		this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
		document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

		this.onupdatedevices_handler({detail: application.devices});

		this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
		this.spinnerTargetMLH.value = this.textboxCurrentMLH.value;
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
	}
	buttonClose_click(event) {
		this.close();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.antifoamPump.id;
		this.textboxDeviceStatus.value = devices.antifoamPump.status;
		this.textboxCurrentRPM.value = devices.antifoamPump.rpm;
		this.textboxCurrentMLH.value = devices.antifoamPump.mlh;
		this.textboxCalibrationStatus.value = devices.antifoamPump.calibrationStatus;
	}
	spinnerTargetRPM_change(event) {
		server.rcall("RM_antifoampump_setRPM", this.spinnerTargetRPM.value).catch(function(result) {
			alert(result);
		});
	}
	spinnerTargetMLH_change(event) {
		server.rcall("RM_antifoampump_setMLH", this.spinnerTargetMLH.value).catch(function(result) {
			alert(result);
		});
	}
	buttonCalibrate_click(event) {
		this.iconCalibrate.iconname = "view-refresh";
		server.rcall("RM_antifoampump_calibrate", this.spinnerCalibrationRPM.value, this.spinnerCalibrationMLH.value).then(function(result) {
			this.iconCalibrate.iconname = "dialog-ok-apply";
		}.bind(this)).catch(function(result) {
			this.iconCalibrate.iconname = "process-stop";
		}.bind(this));
	}
}

ConfigAntifoamPumpDialog.constructor();

export default ConfigAntifoamPumpDialog;